//import Vue from 'vue'
import Vue from 'vue/dist/vue.esm.js'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"


Vue.use(Vuex);

const state = {//要设置的全局访问的state对象
    // uid: "",
    // token: "",
    role: [],
    collapse: true,
    emProvinces: "",//设备监控
    emCity: "",
    emStation: "",
    eleProvinces: "",//用电监控
    eleCity: "",
    eleStation: "",
    eleChargersName:"",
    // slProvinces: "",//场站列表
    videoProvince:"",   //视频监控
    videoCity:"",
    videoStation:"",
    crProvinces: "",//充电收入
    crCity: "",
    crStation: "",
    sideBarHeight:"",//左侧栏高度
    // 下面全部是重复接口数据
    alarmType:"",
    getDayMonthRunningStatus:"",
    getDayMonthPowerServFee:"",
    getMapStations:"",
    getStationIncomeSort:"",
    getChargerTypes:"",
    getDayMonthChargingStatistics:"",
    getChargersSortbyOperation:"",
    getTotalState:"",
    monthDay:"",
    alarmNum:"",
    provinceValue:"",
    cityValue:"",
    stationValue:""
};
const getters = {   //实时监听state值的变化(最新状态)
    // isUid(state) {  //方法名随意,主要是来承载变化的showFooter的值
    //    return state.uid
    // },
    // isToken(state) {  //方法名随意,主要是来承载变化的showFooter的值
    //     return state.token
    // },
    isRole(state) {  //方法名随意,主要是来承载变化的showFooter的值
        return state.role
    },
    isChangeMsg() {
        return state.collapse;
    },
    isEmProvinces() {//设备监控
        return state.emProvinces;
    },
    isEmCity() {
        return state.emCity;
    },
    isEmStation(){
        return state.emStation;
    },
    isEleProvinces() {//用电监控
        return state.eleProvinces;
    },
    isEleCity() {
        return state.eleCity;
    },
    isEleStation(){
        return state.eleStation;
    },
    isEleChargers(){
        return state.eleChargersName;
    },
    isvideoProvinces() {//视频监控
        return state.videoProvince;
    },
    isvideoCity() {
        return state.videoCity;
    },
    isvideoStation(){
        return state.videoStation;
    },
    isCrProvinces() {//充电收入
        return state.crProvinces;
    },
    isCrCity() {
        return state.crCity;
    },
    isCrStation(){
        return state.crStation;
    },
    isSideBarHeight(){
        return state.sideBarHeight;
    },
};
const mutations = {
    // REMOVE_COOKIES: (state) => {
    //     setCookie("uid", "");
    //     setCookie("token", "");
    //     setCookie("uname", "");
    //     localStorage.setItem('userInfo', '');
    // },
    changeRole(state, newVal) {
        state.role = newVal;
    },
    changeMsg(state, newVal) {
        state.collapse = newVal;
    },
    changeEmProvinces(state, newVal) {//设备监控
        state.emProvinces = newVal;
    },
    changeEmCity(state,newVal){
        state.emCity = newVal;
    },
    changeEmStation(state,newVal){
        state.emStation = newVal;
    },
    changeEleProvinces(state, newVal) {//用电监控
        state.eleProvinces = newVal;
    },
    changeEleCity(state,newVal){
        state.eleCity = newVal;
    },
    changeEleStation(state,newVal){
        state.eleStation = newVal;
    },
    changeEleChargers(state,newVal){
        state.eleChargersName = newVal;
    },
    changevideoProvinces(state, newVal) {//视频监控
        state.videoProvince = newVal;
    },
    changevideoCity(state,newVal){
        state.videoCity = newVal;
    },
    changevideoStation(state,newVal){
        state.videoStation = newVal;
    },
    changeCrProvinces(state, newVal) {//充电收入
        state.crProvinces = newVal;
    },
    changeCrCity(state,newVal){
        state.crCity = newVal;
    },
    changeCrStation(state,newVal){
        state.crStation = newVal;
    },
    changeSideBarHeight(state,newVal){
        state.sideBarHeight = newVal;
    },
    alarmType(state,newVal){
        state.alarmType=newVal
    },
    getDayMonthRunningStatus(state,newVal){
        state.getDayMonthRunningStatus=newVal
    },
    getDayMonthPowerServFee(state,newVal){
        state.getDayMonthPowerServFee=newVal
    },
    getMapStations(state,newVal){
        state.getMapStations=newVal
    },
    getStationIncomeSort(state,newVal){
        state.getStationIncomeSort=newVal
    },
    getChargerTypes(state,newVal){
        state.getChargerTypes=newVal
    },
    getDayMonthChargingStatistics(state,newVal){
        state.getDayMonthChargingStatistics=newVal
    },
    getChargersSortbyOperation(state,newVal){
        state.getChargersSortbyOperation=newVal
    },
    getTotalState(state,newVal){
        state.getTotalState=newVal
    },
    MonthDay(state,newVal){
        state.monthDay=newVal
    },
    AlarmNum(state,newVal){
        state.alarmNum=newVal
    },
    ProvinceValue(state,newVal){
        state.provinceValue=newVal
    },
    CityValue(state,newVal){
        state.cityValue=newVal
    },
    StationValue(state,newVal){
        state.stationValue=newVal
    }
    
};
const actions = {
    // 退出
    // LogOut({ commit, state }) {
    //     return new Promise((resolve, reject) => {
    //         localStorage.setItem('userInfo', {});
    //         commit('REMOVE_COOKIES');
    //         // commit('SET_ROLES', []);
    //         setTimeout("location.reload()", 300); // 为了重新实例化vue-router对象 避免bug
    //         resolve();
    //     })
    // },
    // getChangeMsg(context,newVal){
    //     context.commit('changeMsg',newVal)
    // },
}

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    plugins: [createPersistedState({
        storage: window.localStorage
    })]
});

export default store;